var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "short-left-arrow",
  "use": "short-left-arrow-usage",
  "viewBox": "0 0 167.626 135.243",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 167.626 135.243\" id=\"short-left-arrow\">\r\n<g id=\"short-left-arrow__x31_\">\r\n\t<path d=\"M167.626,76.997H26.558l49.066,48.697l-9.892,9.549L0,69.538L63.57,0l10.326,9.615L25.527,62.997h142.099V76.997z\" />\r\n</g>\r\n<g id=\"short-left-arrow__x32_\">\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/short-left-arrow.icon
// module id = 130
// module chunks = 168707334958949